// @devNote: Selectors are WDS markup (.destination-container, .upper-container, input.native-input).
// Ceiling: a design-system release that renames those nodes makes this a no-op.
// Characters typed after this module evaluates and before hydration are still wiped.
// Upgrade: replay focus inside SearchFormInline, SearchFormStandalone, and SearchFormStacked on mount.

const DESTINATION_FIELD_SELECTOR = '.destination-container, .upper-container';
const DESTINATION_INPUT_SELECTOR = '.destination-container input.native-input';

let textTypedBeforeHydration = '';

function query(root, selector) {
  if (!root || typeof root.querySelector !== 'function') {
    return null;
  }

  return root.querySelector(selector);
}

export function captureDestinationTextBeforeHydration() {
  if (typeof document === 'undefined') {
    return;
  }

  const active = document.activeElement;
  if (!(active instanceof HTMLInputElement) || !active.matches(DESTINATION_INPUT_SELECTOR)) {
    return;
  }

  textTypedBeforeHydration = active.value;
}

function scheduleClearTypedDestinationText() {
  queueMicrotask(() => {
    textTypedBeforeHydration = '';
  });
}

function restoreTypedDestinationText(input) {
  const typed = textTypedBeforeHydration;
  if (!typed || input.value) {
    return;
  }

  textTypedBeforeHydration = '';
  input.value = typed;
  input.dispatchEvent(new Event('input'));
}

if (import.meta.client) {
  captureDestinationTextBeforeHydration();
}

export function replayActiveSearchFocus({
  activeElement,
  inlineRoot,
  phoneRoot,
  onPhone,
}) {
  scheduleClearTypedDestinationText();

  if (!activeElement) {
    return;
  }

  const inlineInput = query(inlineRoot, DESTINATION_INPUT_SELECTOR);
  if (inlineInput && activeElement === inlineInput) {
    activeElement.dispatchEvent(new FocusEvent('focus'));
    restoreTypedDestinationText(inlineInput);
    return;
  }

  const phoneField = query(phoneRoot, DESTINATION_FIELD_SELECTOR);
  if (phoneField?.contains(activeElement)) {
    onPhone?.();
  }
}
